import { AxiosError } from 'axios';
import { UserNotificationListRequest } from './userNotification.types';
import { useInfiniteQuery, useMutation } from 'react-query';
import userNotificationServices from './userNotification.services';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import notificationError from '@/utils/functions/notificationError';

export const USER_NOTIFICATION_LIST_KEY = 'user-notification/filter';

export function useUserNotificationListFilter(
  params?: UserNotificationListRequest,
  enabled = true,
) {
  return useInfiniteQuery({
    queryKey: [USER_NOTIFICATION_LIST_KEY, { ...params }],
    queryFn: ({ pageParam }) =>
      userNotificationServices.listFilter({
        rows: 10,
        order: 'DESC',
        ...params,
        nextToken: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextToken,
    enabled:
      ((!!params?.startDate && !!params?.endDate) ||
        (!params?.startDate && !params?.endDate)) &&
      enabled,
  });
}

export function useUserNotificationMarkAsRead() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: userNotificationServices.markAsRead,
    async onSuccess() {
      queryChanel({ invalidateQueries: [[USER_NOTIFICATION_LIST_KEY]] });
    },
    onError(error: AxiosError) {
      notificationError(error);
    },
  });
}

export function useUserNotificationMarkAllAsRead() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: userNotificationServices.markAllAsRead,
    async onSuccess() {
      queryChanel({ invalidateQueries: [[USER_NOTIFICATION_LIST_KEY]] });
    },
    onError(error: AxiosError) {
      notificationError(error);
    },
  });
}

export function useUserNotificationMarkAsDismissed() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: userNotificationServices.markAsDismissed,
    async onSuccess() {
      queryChanel({ invalidateQueries: [[USER_NOTIFICATION_LIST_KEY]] });
    },
    onError(error: AxiosError) {
      notificationError(error);
    },
  });
}
